/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */

/**
 * I am a query to seek the company's configuration
 */
export const FETCH_COMPANY_CONFIG = gql`
query CompanyConfig {
    companyConfig {
        __typename
        ...on CompanyConfig {
            customersVisibility {
                noWallet
                onlyOwn
            }
            flagUserId
            partner
            telephony {
                active
            }
        }
        ...on Error {
            code
            info
        }
    }
}
`;


/**
 * I am a query to fetch company dynamics.
 */
export const FETCH_COMPANY_DYNAMICS = gql`
query CompanyDynamics {
    companyDynamics {
        __typename

        ... on CompanyDynamics {
            variables
        }

        ... on Error {
            code
            info
        }
    }
}`;


/**
 * I am a query to fetch kanbans.
 */
export const FETCH_KANBANS = gql`
query kanbans {
    kanbans {
        id
        name
        prio
        tag
    }
}`;


/**
 * I am a query to fetch queues.
 */
export const FETCH_QUEUES = gql`
query Queues {
    queues {
        agents {
            uid
        }
        id
        name
        scheduler {
            type
        }
    }
}`;


/**
 * I am a query fetch user config
 */
export const FETCH_USER_CONFIG = gql`
query UserConfig {
    userConfig {
        __typename
        ...on UserConfig {
            ai {
                apiKey
            }
            answerAlert
            menu
            messages {
                key
                body
            }
            prompts {
                qualityReport
            }
        }
        ...on Error {
            code
            info
        }
    }
}
`;
